import Events from "nom-events";
import Key from "./Key";

export class Keyboard {
    constructor() {
        this.keyStates = new Map();
        this.events = new Events();
    }

    clear() {
        this.keyStates.clear();
    }

    update() {
        this.keyStates.forEach((value, keyCode) => {
            const event = this.keyStates.get(keyCode);

            event.alreadyPressed = true;

            if (event.wasReleased) {
                this.keyStates.delete(keyCode);
            }

            keyboard.events.call("down", keyCode, event);
            keyboard.events.call("down_" + keyCode, keyCode, event);
        });
    }

    isKeyDown(...args) {
        let result = false;
        for (let keyCode of args) {
            const event = this.keyStates.get(keyCode);
            if (event && !event.wasReleased)
                result = true;
        }

        return result;
    }

    isKeyUp(...args) {
        return !this.isKeyDown(args);
    }

    isKeyPressed(...args) {
        let result = false;

        if (args.length == 0)
            return false;

        for (let keyCode of args) {
            const event = this.keyStates.get(keyCode);
            if (event && !event.wasReleased && !event.alreadyPressed)
                result = true;
        }

        return result;
    }

    isKeyReleased(...args) {
        let result = false;

        if (args.length == 0)
            return false;

        for (let keyCode of args) {
            const event = this.keyStates.get(keyCode);
            if (event && event.wasReleased)
                result = true;
        }

        return result;
    }
}

const keyboard = new Keyboard();
Keyboard.keyboard = keyboard;

window.addEventListener("keydown", (event) => {
    if (!keyboard.keyStates.get(event.keyCode)) {
        keyboard.keyStates.set(event.keyCode, event);
        keyboard.events.call("pressed", event.keyCode, event);
        keyboard.events.call("pressed_" + event.keyCode, event.keyCode, event);
    }
}, false);

window.addEventListener("keyup", (event) => {
    event = keyboard.keyStates.get(event.keyCode);
    if (event) {
        //keyboard.keyStates.set(event.keyCode, event);
        event.wasReleased = true;
        keyboard.events.call("released", event.keyCode, event);
        keyboard.events.call("released_" + event.keyCode, event.keyCode, event);
    }
}, false);

window.addEventListener("click", (event) => {
    const altEvent = keyboard.keyStates.get(Key.ALT);
    const ctrlEvent = keyboard.keyStates.get(Key.CTRL);
    const shiftEvent = keyboard.keyStates.get(Key.SHIFT);

    const releaseEvent = (e) => {
        e.wasReleased = true;
        keyboard.events.call("released", e.keyCode, e);
        keyboard.events.call("released_" + e.keyCode, e.keyCode, e);
    };

    if (altEvent && !event.altKey) {
        releaseEvent(altEvent);
    } else if (ctrlEvent && !event.ctrlKey) {
        releaseEvent(ctrlEvent);
    } else if (shiftEvent && !event.shiftKey) {
        releaseEvent(shiftEvent);
    }
}, true);
